/** Module ordering for CRM apps — ported verbatim from WEB. */
export const CRM_PERMISSION_MODULE_ORDER = [
  'logs',
  'leads',
  'lead',
  'opportunities',
  'opportunity',
  'contracts',
  'contact',
  'tasks',
  'task',
  'calls',
  'call',
  'documents',
  'document',
  'reports',
  'nomenclatures',
  'nomenclature',
  'automations',
  'automation',
  'users',
  'user',
  'integrations',
  'integration',
  'settings',
  'exports',
  'export',
  'invoices',
  'invoice',
  'campaigns',
  'campaign',
  'information'
]

/** Human labels for select CRM modules — ported verbatim from WEB. */
export const CRM_PERMISSION_MODULE_LABELS: Record<string, string> = {
  logs: 'Activities',
  contact: 'Contacts',
  task: 'Tasks',
  call: 'Calls',
  document: 'Documents',
  nomenclature: 'Nomenclatures',
  automation: 'Automations',
  user: 'Agents',
  integration: 'Integrations',
  export: 'Exports',
  invoice: 'Invoices',
  sequence: 'Campaigns'
}

/** Action precedence for sorting permissions inside a single cell. */
export const ACTION_ORDER = [
  'view',
  'create',
  'edit',
  'update',
  'delete',
  'approve',
  'complete',
  'cancel',
  'convert',
  'remove'
]

export const SELECT_ALL = '__select_all__'

export type RolePermissionsMap = {
  [module: string]: number[]
}

export const CRM_INSTANCE_TYPE = 'crm'
export const HRMS_INSTANCE_TYPE = 'hrms'
